import { z } from 'zod';

const createReceiptSchema = z.object({
    outreach_id: z.uuid(),
    runner_run_id: z.uuid(),
    runner_conversation_id: z.uuid(),
    shift_ids: z.array(z.uuid()),
});

const detailReceiptSchema = z.object({
    render_artifact: z.object({
        component: z.literal('outreach_detail'),
        outreach_id: z.uuid(),
    }),
});

export function parseOutreachReceipt(
    toolName: string | undefined,
    output: unknown,
) {
    switch (toolName) {
        case 'create_outreach': {
            const receipt = createReceiptSchema.safeParse(output);
            return receipt.success
                ? {
                      kind: 'outreach' as const,
                      outreachId: receipt.data.outreach_id,
                      heading: 'created' as const,
                  }
                : null;
        }
        case 'render_dynamic_ui': {
            const receipt = detailReceiptSchema.safeParse(output);
            return receipt.success
                ? {
                      kind: 'outreach' as const,
                      outreachId: receipt.data.render_artifact.outreach_id,
                      heading: 'existing' as const,
                  }
                : null;
        }
        default:
            return null;
    }
}
